/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SortInDir } from './sortInDir';

export interface SortIn {
  column: string;
  dir?: SortInDir;
}
